<template>
  <div class="certificate-info-container">
    <van-nav-bar title="证书信息" />
    <div class="certificate-info-header">
      <!-- <div class="certificate-info-header-title">证书信息</div> -->
      <div class="certificate-info-header-content">
        <div class="content-item" v-for="(item, index) in info" :key="index">
          <div class="tem-title">{{ item.title }}</div>
          <div class="item-value">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { get } from "@/request.js";
const route = useRoute();

const info = ref([]);
const certId = ref("");

const getInfo = async () => {
  try {
    const res = await get(`/api/certs/issued/${certId.value}`);
    // 把data中的数据赋值给info
    const data = res.data || {};
    info.value = Object.keys(data).map((key) => ({
      title: key,
      value: data[key],
    }));
  } catch (error) {
    console.error("获取证书信息失败:", error);
  }
};
onMounted(() => {
  certId.value = route.query.certId;

  getInfo();
});
</script>
<style scoped lang="less">
.certificate-info-container {
  width: 100%;
  height: 100vh;
  .certificate-info-header {
    padding: 15px;
    margin: 15px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    .certificate-info-header-title {
      font-size: 18px;
      font-weight: 600;
      color: #1f2937;
      padding-bottom: 20px;
    }
    .content-item {
      display: flex;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #f5f5f5;
      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }
      .tem-title {
        font-size: 16px;
        color: #1f2937;
        padding-right: 20px;
      }
      .item-value {
        font-size: 16px;
        color: #666;
      }
    }
  }
}
</style>
